import { render, staticRenderFns } from "./Citacao.vue?vue&type=template&id=46c16362&scoped=true"
import script from "./Citacao.vue?vue&type=script&lang=js"
export * from "./Citacao.vue?vue&type=script&lang=js"
import style0 from "./Citacao.vue?vue&type=style&index=0&id=46c16362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c16362",
  null
  
)

export default component.exports